
























import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineChem1LCLabReport1Procedure',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        procedureAnswer: null,
      },
      questions: [
        {
          text: 'In the space below, please write your procedure.',
          inputName: 'procedureAnswer',
          maxInputLength: 1000,
        },
      ],
    };
  },
});
